










































































import Vue, { PropType } from "vue"
import PCardList from "./local/PCardList.vue"
import PCardListItem from "./local/PCardListItem.vue"
import PFullCardListItem from "./local/PFullCardListItem.vue"
import CInfiniteScrollList from "~/components/custom/baseList/CInfiniteScrollList.vue"
import {
  UserProfileSearchResultView,
  decorateUserProfileSearchResultView,
} from "~/backendApis/viewModel"

interface Impression {
  userId: string
  order: number
}

export interface ImpressedEmitArgument {
  impressions: Impression[]
}

export interface ToggleFavoriteStatusEmitArgument {
  universalUid: string
}

export default Vue.extend({
  components: {
    PCardList,
    PCardListItem,
    PFullCardListItem,
    CInfiniteScrollList,
  },
  props: {
    profiles: {
      type: Array as PropType<UserProfileSearchResultView[]>,
      required: true,
    },
    isFetchableNext: {
      type: Boolean,
      required: true,
    },
    isFullInfoList: {
      type: Boolean,
      default: false,
    },
    enableFavorite: {
      type: Boolean,
      default: false,
    },
    favoriteUniversalUids: {
      type: Array as PropType<string[]>,
      default: () => [],
    },
  },
  computed: {
    // ユーザーIDを入れるための属性（Attribute）のキー。
    userIdDataKey() {
      return "data-user-id"
    },
    // 順番（上から何番目に表示されているか）を入れるための属性（Attribute）のキー。
    orderDataKey() {
      return "data-order"
    },
  },
  watch: {
    profiles() {
      // DOMの更新が完了してから処理を実行する。
      this.$nextTick(() => this.handleItemImpression())
    },
  },
  methods: {
    /**
     * インプレッションを扱う処理。
     * 画面に見えているプロフィールをインプレッションありと見做して、emitでIDをパスしている。
     */
    handleItemImpression() {
      if (!this.$refs.item) {
        return
      }
      const items = this.$refs.item as Vue[]
      const windowHeight = window.innerHeight
      const impressions = items
        .filter((i: Vue) => {
          const elmHeight = i.$el.getBoundingClientRect().height
          const elmPositionY = i.$el.getBoundingClientRect().y

          // 画面の縦幅に収まっている要素のみに絞り込む
          return elmPositionY >= 0 && elmPositionY + elmHeight <= windowHeight
        })
        // data属性としてユーザーIDと順番を保持しているため、そこからそれぞれの値を取得する。
        .map((i) => ({
          userId: i.$el.getAttribute(this.userIdDataKey),
          order: Number(i.$el.getAttribute(this.orderDataKey)),
        }))
        .filter((i) => i.userId && i.order)
      const args: ImpressedEmitArgument = {
        impressions: impressions as Impression[], // filterだとnullableのままになるため、止む無くキャストしている。
      }
      this.$emit("impressed", args)
    },
    handleTouchBottomOfProfileList() {
      this.$emit("touch-bottom-of-profile-list")
    },
    userProfileDecorator(userProfile: UserProfileSearchResultView) {
      return decorateUserProfileSearchResultView(userProfile)
    },
    getMainCorporationName(userProfile: UserProfileSearchResultView) {
      return decorateUserProfileSearchResultView(
        userProfile
      ).getMainExperienceCorporation()?.corporationName
    },
    getIsLeadingCompany(userProfile: UserProfileSearchResultView) {
      const mainCorporation = decorateUserProfileSearchResultView(
        userProfile
      ).getMainExperienceCorporation()

      return mainCorporation?.isLeadingCompany
    },
    getMainCorporationEnrolledStatus(userProfile: UserProfileSearchResultView) {
      return decorateUserProfileSearchResultView(
        userProfile
      ).getMainExperienceCorporation()?.isCurrentCorporation
    },
    getLastAccessStatus(userProfile: UserProfileSearchResultView) {
      return decorateUserProfileSearchResultView(
        userProfile
      ).getLastAccessStatus()
    },
    handleToggleFavoriteStatus(universalUid: string) {
      const arg: ToggleFavoriteStatusEmitArgument = {
        universalUid,
      }
      this.$emit("toggle-favorite-status", arg)
    },
    handleClickScoutButton(universalUid: string) {
      this.$emit("click-scout-button", universalUid)
    },
    isFavoriteUser(universalUid: string): boolean {
      return this.favoriteUniversalUids.includes(universalUid)
    },
  },
})
